import axios from "axios"
import { env } from "../config"
import { REVIEW_ARCHIVE_PAGE_SIZE } from "../lib/reviews/constants"

const API_TIMEOUT = 10000

const apiClient = axios.create({ timeout: API_TIMEOUT })

const helpers = {
  getReviews: (pageNumber = 1, filters = {}) => {
    const params = new URLSearchParams({ page: String(pageNumber) })

    if (filters.perPage) {
      params.set("per_page", String(filters.perPage))
    }

    if (filters.sort) {
      params.set("sort", filters.sort)
    }

    if (filters.category) {
      params.set("category", filters.category)
    }

    if (filters.subcategory) {
      params.set("subcategory", filters.subcategory)
    }

    return apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/reviews?${params.toString()}`,
    )
  },

  getReviewMonths: () =>
    apiClient.get(`${env("DAEDALUS_API_HOST")}/api/reviews/months`),

  getReviewArchive: ({ kind, period, page }) => {
    const params = new URLSearchParams({
      [kind]: period,
      page: String(page),
      per_page: String(REVIEW_ARCHIVE_PAGE_SIZE),
      sort: "newest",
    })

    return apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/reviews?${params.toString()}`,
    )
  },

  getCityExportData: (city, state) => {
    const url = `${env(
      "DAEDALUS_API_HOST",
    )}/api/shipments/recent/from?state=${state}&city=${city}`

    console.log("Calling export API:", url)

    return apiClient.get(url)
  },

  getCityImportData: (city, state) => {
    const url = `${env(
      "DAEDALUS_API_HOST",
    )}/api/shipments/recent/to?state=${state}&city=${city}`

    console.log("Calling import API:", url)

    return apiClient.get(url)
  },

  getStateExportData: (state) =>
    apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/shipments/recent/from?state=${state}`,
    ),
  getStateImportData: (state) =>
    apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/shipments/recent/to?state=${state}`,
    ),
  getCityTransporters: (city, state) => {
    const url = `${env(
      "DAEDALUS_API_HOST",
    )}/api/drivers/best?state=${state}&city=${city}`

    console.log("Calling transporters API:", url)

    return apiClient.get(url)
  },
  getStateTransporters: (state) =>
    apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/drivers/best?state=${state}&limit=6`,
    ),
  createShipment: (data, token) => {
    return apiClient.post(`${env("DAEDALUS_API_HOST")}/api/shipments`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },
  validateShipment: (data) => {
    return apiClient.post(
      `${env("DAEDALUS_API_HOST")}/api/validate/shipments`,
      data,
    )
  },
  previousShipment: () => {
    return apiClient.get(
      `${env("DAEDALUS_API_HOST")}/api/shipments/recent/from`,
    )
  },
}

export default helpers
